import { useParams } from 'react-router-dom';

type RouteParams = {
	readonly interview?: string;
	readonly localInterview?: string;
};

const useInterviewIdParams = () => {
	const { interview, localInterview } = useParams<RouteParams>();

	const isServerRoute = interview !== undefined;
	const isLocalRoute = localInterview !== undefined;
	const interviewId = interview !== undefined ? Number(interview) : Number.NaN;
	const isInvalidServerSegment = isServerRoute && Number.isNaN(interviewId);
	const isInvalidLocalSegment = isLocalRoute && localInterview.length === 0;
	const isInvalidSegment = isInvalidServerSegment || isInvalidLocalSegment;

	return {
		interviewId,
		localInterviewId: localInterview ?? null,
		isInvalidServerSegment,
		isInvalidLocalSegment,
		isInvalidSegment,
	};
};

export default useInterviewIdParams;
